import { SAGA_ACTIONS } from "src/_config";
import { useApiCall } from "../common/appApiCallHook";
import {
  AddAvailabilityPayload,
  ScheduleRequestPayload,
  RescheduleOrCancelPayload,
} from "src/_common/interfaces/ApiReqRes";

export function useInterviewApi() {
  const callApi = useApiCall();

  const addAvailability = (data: AddAvailabilityPayload, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.INTERVIEW.ADD_AVAILABILITY, data, onSuccess, onError);
  };

  const addUnavailability = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.INTERVIEW.ADD_UNAVAILABILITY, data, onSuccess, onError);
  };

  const deleteUnavailability = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.INTERVIEW.DELETE_UNAVAILABILITY, data, onSuccess, onError);
  };

  const getSchedule = (data: any = {}, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.INTERVIEW.GET_SCHEDULE, data, onSuccess, onError);
  };

  // New API hook for available time slots
  const getAvailableTimeSlots = (data: { member_id: string }, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.INTERVIEW.GET_AVAILABLE_TIME_SLOTS, data, onSuccess, onError);
  };

  const scheduleRequest = (data: ScheduleRequestPayload, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.INTERVIEW.SCHEDULE_REQUEST, data, onSuccess, onError);
  };

  const scheduleRequestAI = (data: ScheduleRequestPayload, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.INTERVIEW.SCHEDULE_REQUEST_AI, data, onSuccess, onError);
  };

  const getVideoCallData = (data: { interviewId: string }, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.INTERVIEW.GET_VIDEO_CALL_DATA, data, onSuccess, onError);
  };

  const rescheduleOrCancel = (data: RescheduleOrCancelPayload, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.INTERVIEW.RESCHEDULE_OR_CANCEL, data, onSuccess, onError);
  };

  const updateValidity = (
    data: { screening_id: string; validity_time: number },
    onSuccess: Function,
    onError: Function,
  ) => {
    callApi(SAGA_ACTIONS.INTERVIEW.UPDATE_VALIDITY, data, onSuccess, onError);
  };

  const submitInterviewFeedback = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.INTERVIEW.SUBMIT_FEEDBACK, data, onSuccess, onError);
  };

  const getInterviewEvaluation = (data: { schedule_id: string }, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.INTERVIEW.GET_EVALUATION, data, onSuccess, onError);
  };

  return {
    callAddAvailability: addAvailability,
    callAddUnavailability: addUnavailability,
    callDeleteUnavailability: deleteUnavailability,
    callGetSchedule: getSchedule,
    callGetAvailableTimeSlots: getAvailableTimeSlots,
    callScheduleRequest: scheduleRequest,
    callScheduleRequestAI: scheduleRequestAI,
    callGetVideoCallData: getVideoCallData,
    callRescheduleOrCancel: rescheduleOrCancel,
    callUpdateValidity: updateValidity,
    callSubmitInterviewFeedback: submitInterviewFeedback,
    callGetInterviewEvaluation: getInterviewEvaluation,
  };
}
